import SyncableModel from "../../database/SyncableModel"
import { File } from "../../database"
import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import { BaseModelStoreProps } from "../base-model-store/base-model-store"
import { withBaseModel } from "../extensions/with-base-model"

const FileStoreProps = {
  ...BaseModelStoreProps
}

/**
 * Model description here for TypeScript hints.
 */
export const FileStoreModel = types
  .model("FileStore")
  .props(FileStoreProps)
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof FileStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init() {
      self.initModel();
    },
    async store(data) {
      if (self.rootStore.appStore?.isOffline)
        return this.storeOffline(data)
      return self.storeModel(File, data, true);
    },
    async storeOffline(data) {
      return self.storeModelOffline(File, data, true);
    },
    async update(model: SyncableModel, data) {
      if (self.rootStore.appStore?.isOffline)
        return this.updateOffline(model, data)
      return self.updateModel(File, model, data, true);
    },
    async updateOffline(model: SyncableModel, data) {
      return self.updateModelOffline(File, model, data, true);
    },
    async delete(model: SyncableModel) {
      if (self.rootStore.appStore?.isOffline)
        return this.deleteOffline(model)
      return self.deleteModel(File, model, true);
    },
    async deleteOffline(model: SyncableModel) {
      return self.deleteModelOffline(File, model, true);
    }
  }))

type FileStoreType = Instance<typeof FileStoreModel>
export interface FileStore extends FileStoreType {}
type FileStoreSnapshotType = SnapshotOut<typeof FileStoreModel>
export interface FileStoreSnapshot extends FileStoreSnapshotType {}
export const createFileStoreDefaultModel = () => types.optional(FileStoreModel, {})
